module.exports = __webpack_public_path__ + "static/media/rejected-order.75a9a233.svg";